// extracted by mini-css-extract-plugin
export default {"labelBackground":"CustomTextArea_labelBackground__xoYrM","noPadding":"CustomTextArea_noPadding__D4NMO"};